<template>
  <div>
    <div class="line-chart-wrapper">
    <TransitionGroup tag="ul" name="fade-v2" class="line-chart-legend">
      <li v-for="country in countries" :key="country.Id" :class="[ 'legend', getBulletClass(country.Id) ]">
          <span>{{ country.Land }}</span>
      </li>
    </TransitionGroup>
    </div>
    <div ref="chart" class="line-chart"></div>
  </div>
</template>
<script>
import _ from 'lodash';
import * as d3 from 'd3';

export default {
  name: 'linechart',
  props: {
    rankings: Object,
    countries: Array,
  },
  watch: {
    rankings(v, o) {
      this.updateRankings();
    },
    countries(v, o) {
      this.resetChart();
    },
  },
  data() {
    return {
      container: {
        width: 'auto',
        height: 500,
      },
      line: null,
      x: null,
      y: null,
      svg: null,
      aniSpeed: 500,
      radius: 9,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.draw();
    });
  },
  computed: {
    years() {
      let years = this.$store.state.years;
      return _.sortBy(years, function(num) { return num;});
    },
  },
  methods: {
    getBulletClass(countryId) {
      const cIndex = _.findIndex(this.countries, { Id: countryId }) + 1;
      return (cIndex === 0) ? '' : `bullet-${cIndex}`;
    },

    resetChart() {
      const allCharts = this.$el.querySelectorAll('.chart');
      _.forEach(allCharts, (chart) => {
        const chartCountry = chart.getAttribute('country');
        if (_.find(this.countries, c => c.Id === chartCountry) === undefined) {
          d3.select(chart)
            .transition()
            .duration(this.aniSpeed)
            .style('opacity', 0)
            .on('end', function() {
              d3.select(this).remove();
            });
        }
      });
    },

    addLine(data, countryId, chartClass) {
      const that = this;
      this.svg
      .select('.lines')
        .datum(data)
        .append('path')
        .attr('fill', 'none')
        .attr('stroke-width', 1.5)
        .attr('class', `chart line line-${countryId} ${chartClass}`)
        .attr('country', `${countryId}`)
        .attr('d', that.line)
        .attr('opacity', 0)
        .transition()
        .duration(that.aniSpeed)
        .attr('opacity', 1);
    },

    addBubbles(data, countryId, chartClass) {
      const that = this;
      this.svg.select('.bubbles')
        .selectAll(`.bubble-${countryId}`)
        .data(data)
        .enter()
        .append('circle')
        .attr('class', `chart bubble ${chartClass} bubble-${countryId}`)
        .attr('country', `${countryId}`)
        .attr('cx', d => that.x(d.year))
        .attr('cy', d => that.y(d.rang))
        .attr('r', that.radius)
        .attr('opacity', 0)
        .transition()
        .duration(that.aniSpeed)
        .attr('opacity', 1);
    },

    addLabels(data, countryId, chartClass) {
      const that = this;
      this.svg.select('.labels')
        .selectAll(`.label-${countryId}`)
        .data(data)
        .enter()
        .append('text')
        .attr('class', `chart label ${chartClass} label-${countryId}`)
        .attr('country', `${countryId}`)
        .attr('opacity', 0)
        .attr('x', d => that.x(d.year))
        .attr('y', d => that.y(d.rang) + 4)
        .attr('text-anchor', 'middle')
        .text(d => d.rang)
        .transition()
        .duration(that.aniSpeed)
        .attr('opacity', 1);
    },

    /**
    * Update rankings
    */
    updateRankings() {
      const that = this;

      _.forEach(this.countries, (country) => {

        console.log('updateRankings', country);
        const countryId = country.Id;
        const countryClass = country.chartClass;
        let data = that.rankings[countryId];
        data = _.orderBy(data, ['year'], ['asc']);
        const hasPath = this.$el.querySelector(`.line-${countryId}`);

        if (!hasPath) {
          this.addLine(data, countryId, countryClass);
          this.addBubbles(data, countryId, countryClass);
          this.addLabels(data, countryId, countryClass);
        } else {
          d3.select(`.line-${countryId}`)
            .datum(data)
            .transition()
            .duration(that.aniSpeed)
            .attr('class', `chart line line-${countryId} ${countryClass}`)
            .attr('d', that.line);
          

          // Update bubbles
          const bubbles = this.svg.selectAll(`.bubble-${countryId}`)
            .data(data);

          bubbles
            //.enter()
            //.append('circle')
            .attr('country', `${countryId}`)
            .merge(bubbles)
            .transition()
            .duration(that.aniSpeed)
            .attr('cx', d => that.x(d.year))
            .attr('cy', d => that.y(d.rang))
            .attr('r', that.radius)
            .attr('class', `chart bubble ${countryId} ${countryClass} bubble-${countryId}`)

          //bubbles.exit().remove();

          // Update labels
          const labels = this.svg.selectAll(`.label-${countryId}`)
            .data(data);

          labels.enter()
            .append('text')
            .attr('class', `chart label ${countryId} ${countryClass} label-${countryId}`)
            .attr('country', `${countryId}`)
            .attr('opacity', 1)
            .merge(labels)
            .transition()
            .duration(that.aniSpeed)
            .attr('x', d => that.x(d.year))
            .attr('y', d => that.y(d.rang) + 3)
            .attr('text-anchor', 'middle')
            .attr('fill', 'white')
            .text(d => d.rang);
        }
      });
    },
    draw() {
      const countryId = this.countries[0].Id;
      const countryClass = this.countries[0].chartClass;
      let data = this.rankings[countryId];

      data = _.orderBy(data, ['year'], ['asc']);

      const that = this;
      this.container.width = this.$refs.chart.clientWidth;
      this.$refs.chart.style.height = `${this.container.height}px`;

      const margin = { top: 30, right: 30, bottom: 40, left: 50 };
      const width = this.container.width - margin.left - margin.right;
      const height = this.container.height - margin.top - margin.bottom;

      // set SVG
      this.svg = d3.select(this.$refs.chart)
        .append('svg')
        .attr('width', that.container.width)
        .attr('height', that.container.height)
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

      // set achses
      this.x = d3.scalePoint()
        .domain(this.years)
        .range([0, width]);

      this.y = d3.scaleLinear()
        .domain([23, 0])
        .range([height, 0]);

      this.svg.append('g')
        .attr('transform', `translate(0,${height})`)
        .call(d3.axisBottom(that.x))
        .selectAll("text")
        .style("font-size", "11px");

      this.svg.append('g')
        .attr('transform', 'translate(-10, 0)')
        .call(d3.axisLeft(that.y))
        .selectAll("text")
        .style("font-size", "11px");

      // add Y axis label
      this.svg.append('text')
        .attr('class', 'y-axis-label')
        .attr('text-anchor', 'middle')
        .attr('font-size', '12px')
        .attr('x', -20)
        .attr('y', -12)
        .text('Rang');

      this.line = d3.line()
        .x(d => that.x(d.year))
        .y(d => that.y(d.rang));

      this.svg.append('g')
        .attr('class', 'lines');
      this.svg.append('g')
        .attr('class', 'bubbles');
      this.svg.append('g')
        .attr('class', 'labels');
      this.addLine(data, countryId, countryClass);
      this.addBubbles(data, countryId, countryClass);
      this.addLabels(data, countryId, countryClass);
    },
  },
};
</script>
<style lang="scss">

.line-chart {
  position: relative;
  width: 100%;
  overflow: hidden;

  circle {
    fill: $color-bg-widget;
  }

  svg {
    width: 100%;
    height: 100%;
  }

  .label.chart {
    font-size: 12px;
    stroke: none !important;
    fill: $color-white;
    padding: 20px
  }

}

.line-chart-legend {
  display: flex;

  .legend {
    color: $color-white;
    padding: 3px 5px;
    border-radius: $border-radius;
    font-size: 12px;
  }
}

.line-chart-wrapper {
  min-height: 22px;
}

.line-chart-legend {
  position: relative;
  padding: 0;
  margin: 10px 0 0 0;
  display: flex;
  list-style-type: none;
  justify-content: center;
}

.legend {
  padding: 3px 5px;
  margin: 0 5px;
  top: 0;
  box-sizing: border-box;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  color: $color-white;
    padding: 3px 5px;
    border-radius: $border-radius;
    font-size: 12px;
}

/* 1. declare transition */
.fade-v2-move,
.fade-v2-enter-active,
.fade-v2-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-v2-enter-from {
  transform: scaleY(0.01);
}
.fade-v2-leave-to {
  opacity: 0;
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-v2-leave-active {
  position: absolute;
}
</style>
